import {API_URL, authHeaders, jsonHeaders} from "./index";

export async function apiGetGroups() {
    // Le jeton (s'il existe) permet au serveur de révéler l'effectif réel à l'admin / l'agent SAPPM.
    const res = await fetch(`${API_URL}/groups`, {headers: authHeaders()});
    return res.json();
}

export async function apiCreateGroup(name, description, domain, contact_email) {
    const res = await fetch(`${API_URL}/groups`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({name, description, domain, contact_email})
    });
    return res.json();
}

export async function apiDeleteGroup(groupId) {
    const res = await fetch(`${API_URL}/groups/${groupId}`, {
        method: "DELETE",
        headers: authHeaders()
    });
    return res.json();
}

export async function apiUpdateGroupThreshold(groupId, threshold) {
    const res = await fetch(`${API_URL}/groups/${groupId}/threshold`, {
        method: "PATCH",
        headers: jsonHeaders(),
        body: JSON.stringify({threshold})
    });
    return res.json();
}

export async function apiUpdateGroup(groupId, {name, description, domain, contact_email}) {
    const res = await fetch(`${API_URL}/groups/${groupId}`, {
        method: "PATCH",
        headers: jsonHeaders(),
        body: JSON.stringify({name, description, domain, contact_email})
    });
    return res.json();
}
